import React from "react";
import { LegalLayout, LegalBody, useLegalContent } from "../components/LegalContent";
import CookieConsent from "../components/CookieConsent";

const CookiePolicyPage = () => {
  const content = useLegalContent();
  return (
    <div data-testid="cookie-policy-page">
      <LegalLayout title="Cookie Policy" content={content}>
        <LegalBody text={content?.cookie_body} />
      </LegalLayout>
      <CookieConsent />
    </div>
  );
};

export default CookiePolicyPage;
